<template>
  <section>
    <r-title>{{ $t("views.task-list-unsent.title") | titlecase }}</r-title>
    <TaskList
      :tasks="unsubmittedTasks"
      show-customer
      show-upload-date
      show-action
    />
  </section>
</template>

<script>
import { mapGetters } from "vuex";

import TaskList from "@/components/TaskList.vue";

export default {
  name: "TaskListUnsent",
  components: {
    TaskList
  },
  computed: mapGetters(["unsubmittedTasks"]),
  beforeCreate() {
    this.$store.dispatch("loadUnsubmittedTasks");
  }
};
</script>
